import { Flex, Box, Spacer, Button } from '@chakra-ui/react'
import { FC } from 'react'

import useParameters from '@hook/budget/use-parameters'

const BarToggle: FC = () => {
  const { typeGrid, handledTypeGrid } = useParameters()

  return (
    <Flex
      pos="relative"
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="flex-start"
      paddingY={2}
      paddingX={4}
    >
      <Spacer />

      <Box>
        <Button
          fontSize={14}
          size="sm"
          color="primary"
          iconColor="primary"
          borderColor="primary"
          colorScheme="primary"
          onClick={() => handledTypeGrid(1)}
          variant={typeGrid === 1 ? 'outline' : 'ghost'}
        >
          BT LEO
        </Button>
      </Box>

      <Box>
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          color="primary"
          iconColor="primary"
          borderColor="primary"
          colorScheme="primary"
          onClick={() => handledTypeGrid(2)}
          variant={typeGrid === 2 ? 'outline' : 'ghost'}
        >
          Calculo de Margem Media
        </Button>
      </Box>

      <Box>
        <Button
          fontSize={14}
          size="sm"
          marginLeft={2}
          color="primary"
          iconColor="primary"
          borderColor="primary"
          colorScheme="primary"
          onClick={() => handledTypeGrid(3)}
          variant={typeGrid === 3 ? 'outline' : 'ghost'}
        >
          Atualizar Base Orçamento
        </Button>
      </Box>
    </Flex>
  )
}

export default BarToggle
